export const SHARE_STORE_EVENTS = {
  SELECT_SHARE_STORE: "web_select_share_store_method",
  SELECT_SHARE_PRODUCT: "web_select_share_product_method",
};
